import { clientLogger } from "@/lib/client/logger";

interface CleverTapProfilePayload {
	identity: string;
	profileData: Record<string, unknown>;
}

/**
 * Push profile properties with nested objects to CleverTap via REST API.
 * Fire-and-forget: errors are logged but never thrown.
 */
export async function pushCleverTapProfile(
	payload: CleverTapProfilePayload,
): Promise<void> {
	try {
		const response = await fetch("/api/clevertap/profile", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(payload),
		});

		if (process.env.NODE_ENV === "development") {
			const data = await response.json().catch(() => ({}));
			if (response.ok) {
				console.log("CleverTap REST API profile synced:", data);
			} else {
				console.error(
					"CleverTap REST API profile push failed:",
					response.status,
					data,
				);
			}
		}
	} catch (error) {
		clientLogger.error(
			"CleverTap REST profile push error",
			error instanceof Error ? error : undefined,
		);
	}
}
